export default __webpack_public_path__ + "static/media/edital15.efd7af55.pdf";